import axios from "axios";
import IReturnResults from "common/interfaces/IReturnResults";
import { getAxiosErrorReturnResults } from "common/utils/errorHandling";
import { create } from "zustand";

export type LanguageMap = Map<string, string>;
export type LanguagesMap = Map<string, LanguageMap>;

export interface ITranslation {
  displayTextKey: string;
  translatedText: string;
}
type LanguageStore = {
  languages: LanguagesMap;
  loading: boolean;
  fetchLanguages: (apiBaseUrl: string, languageLocale: string) => Promise<IReturnResults>;
}

const useLanguageStore = create<LanguageStore>((set, get) => ({
  languages: new Map(),
  loading: false,

  fetchLanguages: async (apiBaseUrl, languageLocale) => {
    // If language is empty string, it's still intializing
    if (apiBaseUrl === "" || languageLocale === ''){
      return { succeeded: true, errorMessage: null };
    }
    
    const existing = get().languages.get(languageLocale);
    if (existing) {
        console.log(`Locale already exists, not retrieving: ${languageLocale}`)
        return { succeeded: true, errorMessage: null };
      }

    set(() => ({ loading: true }));
    try {
      console.log(`Fetching translation strings for ${languageLocale}`);
      const response = await axios.get(
        `${apiBaseUrl}/api/display/translationstrings?localeName=${languageLocale}`
      );
      set((state) => ({
        languages: new Map([
          ...state.languages,
          [
            languageLocale,
            new Map(
              response.data.translationStrings.map(
                (translation: ITranslation) => [
                  translation.displayTextKey,
                  translation.translatedText,
                ]
              )
            ),
          ],
        ]),
        loading: false,
      }));
      console.log(get().languages.keys());
      return { succeeded: true, errorMessage: null };
    } catch (err) {
      set(() => ({ loading: false }));
      return getAxiosErrorReturnResults(err);
    }
  },
}));

export default useLanguageStore;
